'use client'

import { useTrackOnce } from '@/lib/analytics'

/**
 * Fires the privacy-safe `mist_landing_viewed` event once per landing mount
 * (R-ANA-02). Renders nothing. Lives only in the `(site)` group, never on
 * `/verify` or `/staff`.
 */
export default function LandingAnalytics() {
  useTrackOnce('mist_landing_viewed', { route: '/' })
  return null
}
